var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBreakoutRoom = function SvgBreakoutRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3A3.5 3.5 0 0 0 4 6.5V10a1 1 0 0 0 2 0V6.5A1.5 1.5 0 0 1 7.5 5h11A1.5 1.5 0 0 1 20 6.5v12a1.5 1.5 0 0 1-1.5 1.5H16a1 1 0 0 0 0 2h2.5a3.5 3.5 0 0 0 3.5-3.5v-12A3.5 3.5 0 0 0 18.5 3h-11zM4 13c-1.103 0-2 .897-2 2v5c0 1.103.897 2 2 2h7c1.103 0 2-.897 2-2v-5c0-1.103-.897-2-2-2H4zm0 2h7l.002 5H4v-5z"
  })));
};
export default SvgBreakoutRoom;